export default "__VITE_ASSET__FUsYwSBP__"